module.exports = __webpack_public_path__ + "img/img-placeholder-416.91ba0f3e.png";